const brands = {
	init() {
		this.handleBrands();
	},

	handleBrands() {
		const containers = document.querySelectorAll('[data-brands-az]');

		containers.forEach((container) => {
			this.build(container as HTMLElement);
		});
	},

	build(container: HTMLElement) {
		const source = container.querySelector('[data-brands-source]') as HTMLElement;
		const output = container.querySelector('[data-brands-output]') as HTMLElement;

		if (!source || !output) return;

		const items = source.querySelectorAll('.brand-item') as NodeListOf<HTMLAnchorElement>;
		const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

		output.innerHTML = '';

		letters.forEach((letter) => {
			const matches = Array.from(items).filter((item) => {
				return (item.dataset.letter || '').charAt(0).toUpperCase() === letter;
			});

			if (!matches.length) return;

			output.appendChild(this.createSection(letter, matches));
		});

		this.handleNav(container, output);
		this.handleActiveOnScroll(container, output);
	},

	createSection(letter: string, items: HTMLAnchorElement[]) {
		const section = document.createElement('div');
		section.className = 'brands__group';
		section.id = `brand-${letter}`;
		section.setAttribute('data-brand-group', letter);

		const title = document.createElement('h3');
		title.className = 'brands__letter';
		title.textContent = letter;

		section.appendChild(title);

		items.forEach((item) => {
			section.appendChild(item.cloneNode(true));
		});

		return section;
	},

	handleNav(container: HTMLElement, scrollContainer: HTMLElement) {
		const buttons = container.querySelectorAll('[data-brand-nav]');

		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				const letter = button.getAttribute('data-brand-nav');
				if (!letter) return;

				const target = scrollContainer.querySelector(`#brand-${letter}`) as HTMLElement;
				if (!target) return;

				const containerTop = scrollContainer.getBoundingClientRect().top;
				const targetTop = target.getBoundingClientRect().top;
				const top = targetTop - containerTop + scrollContainer.scrollTop;

				scrollContainer.scrollTo({
					top,
					behavior: 'smooth'
				});

				this.setActiveButton(container, letter);
			});
		});
	},

	handleActiveOnScroll(container: HTMLElement, scrollContainer: HTMLElement) {
		scrollContainer.addEventListener('scroll', () => {
			const groups = scrollContainer.querySelectorAll('[data-brand-group]');
			let currentLetter = '';

			groups.forEach((group) => {
				const el = group as HTMLElement;
				const top = el.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top;

				if (top <= 40) {
					currentLetter = el.getAttribute('data-brand-group') || '';
				}
			});

			if (currentLetter) {
				this.setActiveButton(container, currentLetter);
			}
		});
	},

	setActiveButton(container: HTMLElement, activeLetter: string) {
		const buttons = container.querySelectorAll('[data-brand-nav]');

		buttons.forEach((button) => {
			const letter = button.getAttribute('data-brand-nav');
			button.classList.toggle('activeClass', letter === activeLetter);
		});
	}
};

export default brands;